import type {
  InputParams,
  IViewArticle,
  IViewError,
  IViewFrontpage,
  IViewListing,
  IViewLockedArticle,
  IViewPage,
} from '@schibsted/pulse-sdk';
import type { ByfunnPulseContextInputParams } from '../../types.js';

import { createObjectSdrn } from './create-object-sdrn.js';

type ViewEvent =
  | IViewArticle
  | IViewError
  | IViewFrontpage
  | IViewListing
  | IViewPage
  | IViewLockedArticle;

type PageType =
  | 'Article'
  | 'Error'
  | 'Frontpage'
  | 'Listing'
  | 'Page'
  | 'LockedArticle';

export const buildViewEvent = <TEvent extends ViewEvent>({
  pageType,
  event,
  providerId,
  providerInput,
}: {
  pageType: PageType;
  event: ByfunnPulseContextInputParams<TEvent>;
  providerId: string;
  providerInput: InputParams<TEvent>['provider'];
}): InputParams<TEvent> =>
  ({
    ...event,
    object: {
      ...event.object,
      objectSdrn: createObjectSdrn(providerId, pageType, event.object.objectId),
    },
    provider: providerInput,
  }) as InputParams<TEvent>;
